import { render, staticRenderFns } from "./MembershipCardDetails.vue?vue&type=template&id=085aaf22&scoped=true&"
import script from "./MembershipCardDetails.vue?vue&type=script&lang=js&"
export * from "./MembershipCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./MembershipCardDetails.vue?vue&type=style&index=0&id=085aaf22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085aaf22",
  null
  
)

export default component.exports